/* src/routes/blog/timegame-3-webgl-demo.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	attr,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	safe_not_equal,
	set_style,
	space,
	text,
	transition_in,
	transition_out
} from "../../../_snowpack/pkg/svelte/internal.js";

import PostTop from "../../../_components/Post-Top.svelte.js";
import PostContents from "../../../_components/Post-Contents.svelte.js";
import Callout from "../../../_components/Callout.svelte.js";
import PostSection from "../../../_components/Post-Section.svelte.js";
import Link from "../../../_components/Link.svelte.js";

function create_default_slot_1(ctx) {
	let t0;
	let br;
	let t1;

	return {
		c() {
			t0 = text("Im sorry for the lack of levels and content.\n    ");
			br = element("br");
			t1 = text("\n    This project was mainly for me to try and see what would be needed to\n    implement the time travel piece of functionality");
		},
		l(nodes) {
			t0 = claim_text(nodes, "Im sorry for the lack of levels and content.\n    ");
			br = claim_element(nodes, "BR", {});
			t1 = claim_text(nodes, "\n    This project was mainly for me to try and see what would be needed to\n    implement the time travel piece of functionality");
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			insert(target, br, anchor);
			insert(target, t1, anchor);
		},
		d(detaching) {
			if (detaching) detach(t0);
			if (detaching) detach(br);
			if (detaching) detach(t1);
		}
	};
}

// (15:0) <PostContents>
function create_default_slot(ctx) {
	let t0;
	let callout;
	let t1;
	let iframe;
	let iframe_src_value;
	let current;

	callout = new Callout({
			props: {
				title: "Too boring?",
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			t0 = text("I have created a WEBGL build of the time machine proof of concept game. You\n  should be able to play directly below.\n  ");
			create_component(callout.$$.fragment);
			t1 = space();
			iframe = element("iframe");
			this.h();
		},
		l(nodes) {
			t0 = claim_text(nodes, "I have created a WEBGL build of the time machine proof of concept game. You\n  should be able to play directly below.\n  ");
			claim_component(callout.$$.fragment, nodes);
			t1 = claim_space(nodes);
			iframe = claim_element(nodes, "IFRAME", { style: true, src: true, title: true });
			children(iframe).forEach(detach);
			this.h();
		},
		h() {
			set_style(iframe, "width", "1024px");
			set_style(iframe, "height", "700px");
			if (iframe.src !== (iframe_src_value = "https://gaweph.github.io/TimeGame-WebGL-Demo/V0.01//")) attr(iframe, "src", iframe_src_value);
			attr(iframe, "title", "Marching Squares Linear Interpolation");
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			mount_component(callout, target, anchor);
			insert(target, t1, anchor);
			insert(target, iframe, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const callout_changes = {};

			if (dirty & /*$$scope*/ 4) {
				callout_changes.$$scope = { dirty, ctx };
			}

			callout.$set(callout_changes);
		},
		i(local) {
			if (current) return;
			transition_in(callout.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(callout.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(t0);
			destroy_component(callout, detaching);
			if (detaching) detach(t1);
			if (detaching) detach(iframe);
		}
	};
}

function create_fragment(ctx) {
	let posttop;
	let t;
	let postcontents;
	let current;

	posttop = new PostTop({
			props: {
				title,
				tags: /*tags*/ ctx[0],
				projects: /*projects*/ ctx[1]
			}
		});

	postcontents = new PostContents({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(posttop.$$.fragment);
			t = space();
			create_component(postcontents.$$.fragment);
		},
		l(nodes) {
			claim_component(posttop.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(postcontents.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(posttop, target, anchor);
			insert(target, t, anchor);
			mount_component(postcontents, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const postcontents_changes = {};

			if (dirty & /*$$scope*/ 4) {
				postcontents_changes.$$scope = { dirty, ctx };
			}

			postcontents.$set(postcontents_changes);
		},
		i(local) {
			if (current) return;
			transition_in(posttop.$$.fragment, local);
			transition_in(postcontents.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(posttop.$$.fragment, local);
			transition_out(postcontents.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(posttop, detaching);
			if (detaching) detach(t);
			destroy_component(postcontents, detaching);
		}
	};
}

const title = "Time Game 3 - WEBGL Demo [V0.01]";
const date = "2016-12-29 21:23:00";

function instance($$self) {
	const tags = ["software", "unity3d"];
	const projects = ["Time Travel Game"];
	return [tags, projects];
}

class Timegame_3_webgl_demo extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Timegame_3_webgl_demo;
//# sourceMappingURL=timegame-3-webgl-demo.svelte.js.map
